<template>
  <div class="static top-0 left-0 right-0">
    <img
      class="z-0 w-full h-32 object-cover"
      width="320"
      height="128"
      :src="`${imageProxyUrl}rs:fill:320:128:0/plain/${item.medias.at(0).original_url}`"
    >
  </div>
  <div class="absolute top-0 left-0 right-0 flex h-32 flex-col z-10 justify-between p-4 bg-black bg-opacity-25">
    <div class="flex justify-between">
      <button
        class="w-full flex items-center"
        @click="setOpen(false)"
      >
        <v-icon-chevron-l class="h-6 w-6 text-gray-100" />
        <span class="pl-2 text-left flex-grow text-gray-200 text-base">
          {{ parent.label }}
        </span>
      </button>
      <button
        type="button"
        class="-m-2 p-2 rounded-md inline-flex items-center justify-center"
        @click="setOpen(false) || $emit('close')"
      >
        <span class="sr-only">{{ trans.get('miliboo.common.open') }}</span>
        <v-icon-x class="h-6 w-6 text-gray-100" />
      </button>
    </div>
    <p class="text-lg font-semibold text-gray-100">
      {{ item.label }}
    </p>
  </div>
</template>
<script setup>
import { inject } from 'vue';

defineProps({
  setOpen: {
    type: Function,
    required: true,
  },
  item: {
    type: Object,
    required: true,
  },
  parent: {
    type: Object,
    required: true,
  },
  imageProxyUrl: {
    type: String,
    required: true,
  },
});

defineEmits(['close']);

const trans = inject('translate');

</script>
